import Vue from 'vue'

export default {
  statusAction() {
    return Vue.axios.get('/api/v1/bo/totp/status').then((response) => {
      return response.data
    })
  },
  settingAction() {
    return Vue.axios.get('/api/v1/bo/totp/setting').then((response) => {
      return response.data
    })
  },
  setupAction() {
    return Vue.axios.post('/api/v1/bo/totp/setup').then((response) => {
      return response.data
    })
  },
  confirmAction(data) {
    return Vue.axios.post('/api/v1/bo/totp/confirm', data).then((response) => {
      return response.data
    })
  },
  resetAction(data) {
    return Vue.axios.post('/api/v1/bo/totp/reset', data).then((response) => {
      return response.data
    })
  },
  enableAction(data) {
    return Vue.axios.post('/api/v1/bo/totp/enable', data).then((response) => {
      return response.data
    })
  },
  disableAction(data) {
    return Vue.axios.post('/api/v1/bo/totp/disable', data).then((response) => {
      return response.data
    })
  },
}
